import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=e901c06a&scoped=true&"
import script from "./ReplyMessage.vue?vue&type=script&lang=js&"
export * from "./ReplyMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplyMessage.vue?vue&type=style&index=0&id=e901c06a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e901c06a",
  null
  
)

export default component.exports